<template>
  <div>
    <card type="pricing" :class="`card-${variant} card-white text-center`"
          footer-classes="text-center m-3">
      <div class="card-prices mt-5">
        <h3 :class="`text-on-front text-${variant}`">
          <template v-if="title">{{ title }}</template>
          <span v-else :class="`material-icons jumbo text-${variant}`">{{ error_icon }}</span>
        </h3>
        <h5 class="text-on-back">
          {{ error_on_back }}
        </h5>
        <h3 class="text-black ml-2 mr-2">{{ message }}</h3>
      </div>
      <base-button slot="footer" round :type="variant" @click="backToDashboard" class="btn-just-icon">
        {{$t('messages.errors.no_permission.button')}}
      </base-button>
    </card>
  </div>
</template>
<script>
  import {ZoomCenterTransition} from 'vue2-transitions';
  import {mapGetters, mapActions} from "vuex";
  import vuex from "src/vuex";
  import * as Cookies from "js-cookie";
  export default {
    name: "CardError",
    components: {
      ZoomCenterTransition
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      },
      error_icon:{
        type: String,
        required: false,
        default: "sentiment_dissatisfied"
      },
      title:{
        type: String,
        required: false
      },
      error_on_back:{
        type: String,
        required: true
      },
      message:{
        type: String,
        required: true
      },
      variant: {
        type: String,
        required: false,
        default: "danger"
      }
    },
    data() {
      return {
        showMenu: false,
        menuTransitionDuration: 250,
        pageTransitionDuration: 200,
        year: new Date().getFullYear(),
        pageClass: 'login-page'
      };
    },
    computed: {
      token() {
        return Cookies.getJSON("token");
      },
    },
    methods: {
      ...mapActions(["redirectToMainMenu"]),
      backToDashboard(){
        this.redirectToMainMenu();
      }
    },
  };
</script>
<style lang="scss" scoped>

  .jumbo {
    font-size: 8rem !important;
  }


</style>
